(function() {
  'use strict';

  const RecipientForm = {
    init: function() {
      this.forms = document.querySelectorAll('[data-recipient-form]');
      if (!this.forms.length) return;

      this.forms.forEach(form => this.setupForm(form));
    },

    setupForm: function(form) {
      const checkbox = form.querySelector('.recipient-form__checkbox');
      const fieldsContainer = form.querySelector('[data-recipient-fields]');
      const emailInput = form.querySelector('[data-recipient-email]');
      const nameInput = form.querySelector('[data-recipient-name]');
      const dateInput = form.querySelector('[data-recipient-date]');
      const messageInput = form.querySelector('[data-recipient-message]');
      const charCount = form.querySelector('[data-char-count]');

      if (!checkbox || !fieldsContainer) return;

      // Store all recipient inputs for easy access
      const allInputs = [emailInput, nameInput, dateInput, messageInput].filter(Boolean);

      // Enable checkbox (was disabled by default in HTML)
      checkbox.disabled = false;

      // Set default date to today
      if (dateInput) {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        dateInput.value = formattedDate;
        dateInput.min = formattedDate;
      }

      // Toggle fields visibility and enabled state
      checkbox.addEventListener('change', () => {
        this.toggleFields(fieldsContainer, allInputs, checkbox.checked, emailInput);
      });

      // Character counter for textarea
      if (messageInput && charCount) {
        messageInput.addEventListener('input', () => {
          charCount.textContent = messageInput.value.length;
        });
      }

      // Form validation
      const productForm = form.closest('form');
      if (productForm) {
        productForm.addEventListener('submit', (e) => {
          if (checkbox.checked && emailInput) {
            if (!this.validateEmail(emailInput.value)) {
              e.preventDefault();
              emailInput.classList.add('recipient-form__input--error');
              emailInput.focus();
              alert('Please enter a valid recipient email address.');
              return false;
            }
            emailInput.classList.remove('recipient-form__input--error');
          }
        });
      }

      // Clear error on input
      if (emailInput) {
        emailInput.addEventListener('input', () => {
          emailInput.classList.remove('recipient-form__input--error');
        });
      }

      // Initialize hidden and disabled state
      this.toggleFields(fieldsContainer, allInputs, checkbox.checked, emailInput);
    },

    toggleFields: function(container, inputs, isEnabled, emailInput) {
      if (isEnabled) {
        // Show and enable fields
        container.style.display = 'block';
        container.style.opacity = '1';
        
        inputs.forEach(input => {
          if (input) {
            input.disabled = false;
          }
        });

        if (emailInput) {
          emailInput.required = true;
        }
      } else {
        // Hide and disable fields
        container.style.display = 'none';
        container.style.opacity = '0';
        
        inputs.forEach(input => {
          if (input) {
            input.disabled = true;
          }
        });

        if (emailInput) {
          emailInput.required = false;
        }
      }
    },

    validateEmail: function(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => RecipientForm.init());
  } else {
    RecipientForm.init();
  }

  // Export for external use
  window.RecipientForm = RecipientForm;
})();